module.exports = __webpack_public_path__ + "static/img/icon0.f7790ab3.svg";